import { LiteraturesEffects } from './literatures.effect';
import { ProtocolEffects } from './protocol.effect';

export const effects: any[] = [LiteraturesEffects, ProtocolEffects];

export * from './literatures.effect';
export * from './protocol.effect';
